import { render, staticRenderFns } from "./IndexVideo.vue?vue&type=template&id=7fc52f75&scoped=true&"
import script from "./IndexVideo.vue?vue&type=script&lang=js&"
export * from "./IndexVideo.vue?vue&type=script&lang=js&"
import style0 from "./IndexVideo.vue?vue&type=style&index=0&id=7fc52f75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc52f75",
  null
  
)

export default component.exports